import * as React from 'react';
import { createRoot } from 'react-dom/client';

function Timeline({ events }) {
    const [ page, setPage ] = React.useState(1);
    const postsPerPage = 3;

    // Get total post count we should show.
    let totalPosts = page * postsPerPage;
    totalPosts < events.length ? events.length : totalPosts;

    // Cut events array to the totalPosts count so we can loop through it easily.
    const eventsToDisplay = events.slice( 0, totalPosts );

    const handleLoadMoreOnClick = ( event ) => {
        setPage( page + 1 );
    }

    const timelineClass = totalPosts >= events.length ? 'timeline timeline--end' : 'timeline';
    
    if ( events.length ) {
        return (
            <div className={ timelineClass }>
                <div className="timeline__events">
                    {eventsToDisplay.map((event, index) => (
                        <article key={ index } className="timeline-event">
                            <div className="timeline-event__inner">
                                <time className="timeline-event__date">{event.date}</time>
                                <h1 className="timeline-event__title" dangerouslySetInnerHTML={{ __html: event.title }} />
                                <p className="timeline-event__description" dangerouslySetInnerHTML={{ __html: event.description }} />
                                <figure className="timeline-event__image-wrapper" dangerouslySetInnerHTML={{ __html: event.image }} />
                            </div>
                        </article>
                    ))}
                </div>

                {totalPosts < events.length &&
                    <button 
                        className="timeline__load-more"
                        onClick={ handleLoadMoreOnClick }
                    >
                        Load More
                        <span className="timeline__plus"></span>
                    </button>
                }
            </div>
        );
    } else {
        return '';
    }
}

const element = document.getElementById('timeline-app');
if ( null !== element && timelineAppData ) {
    const root = createRoot( element )
    root.render( <Timeline events={ timelineAppData } /> );
}